import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultarDigitaisIIRGDState } from './types';

export const INITIAL_STATE: ConsultarDigitaisIIRGDState = {
	status: 0,
	data: null,
	mensagens: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultarDigitaisIIRGDState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_DIGITAIS_IIRGD_REQUEST: {
				draft.status = 100;
				break;
			}
			case Types.CONSULTAR_DIGITAIS_IIRGD_SUCCESS: {
				draft.status = 200;
				draft.data = {
					dadosBiometricos: action.payload?.dadosBiometricos
						? action.payload.dadosBiometricos
						: [],
					valida: action.payload.valida,
					motivo: action.payload.motivo,
					origem: action.payload.origem,
				};
				break;
			}
			case Types.CONSULTAR_DIGITAIS_IIRGD_FAILURE: {
				draft.status = action.payload.status;
				draft.data = INITIAL_STATE.data;
				draft.mensagens = action.payload.data.mensagens;
				break;
			}
			case Types.CONSULTAR_DIGITAIS_IIRGD_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.mensagens = INITIAL_STATE.mensagens;
				break;
			}

			default:
		}
		return draft;
	});
}
